/**
 * Generated bundle index. Do not edit.
 */

export {Ng4SpinnerModule,Ng4SpinnerService} from './public_api';

export {Ng4DefaultSpinnerComponent as ɵb} from './src/app/ng4-default-spinner/ng4-default-spinner.component';
export {Ng4SpinnerComponent as ɵa} from './src/app/ng4-spinner/ng4-spinner.component';